import { render, staticRenderFns } from "./RefundSection.vue?vue&type=template&id=3dcdd554&scoped=true"
import script from "./RefundSection.vue?vue&type=script&lang=js"
export * from "./RefundSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcdd554",
  null
  
)

export default component.exports